/**
 * HsaFsaDisclaimer - HSA/FSA eligibility footnote disclaimer
 *
 * Displays fine print explaining HSA/FSA reimbursement eligibility
 * with a link to learn more. Follows LegalDisclaimer pattern.
 */

import { Urls } from '@/constants/urls';

export function HsaFsaDisclaimer() {
  return (
    <p className="text-center text-xs leading-relaxed text-slate-400">
      <sup>1</sup> HSA/FSA eligibility varies by plan. Catch provides itemized
      receipts for reimbursement submission. Reimbursement decisions are made by
      your HSA/FSA plan administrator. Savings estimate of ~30% is based on
      average combined federal, state, and FICA tax rates and will vary by
      individual.{' '}
      <a
        href={Urls.hsa_fsa_learn_more}
        target="_blank"
        rel="noopener noreferrer"
        className="text-slate-400 underline hover:text-slate-500"
      >
        Learn more &rarr;
      </a>
    </p>
  );
}
